@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row.restricted_to_eligible_clients) {
    <p-button
      [label]="'ADMIN.COUPON.ADD_CLIENTS' | translate"
      (click)="GetClients($.row)"
      styleClass="text-sm ml-3 py-1"
    />
  }
}

@if (addClientsModal | async; as show) {
  <coupon-eligible-clients
    [tenantId]="tenantId"
    [couponMaster]="couponMaster"
    [visible]="show"
    (onHide)="closeDialog()"
    (onHide)="closeDialog()"
    (closeEvent)="closeEvent($event)"
  />
}
